import { Button, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

export const DeleteExternalTransactionButton = ({
  onDelete,
}: {
  onDelete: () => void;
}) => {
  return (
    <Popconfirm
      title="Are you sure to delete this transaction?"
      onConfirm={onDelete}
      onCancel={() => {}}
      okText="Yes"
      cancelText="No"
    >
      <Button
        icon={<DeleteOutlined />}
        size="large"
        style={{ display: "flex", alignItems: "center" }}
      >
        Delete transaction
      </Button>
    </Popconfirm>
  );
};
